import TagManager from 'react-gtm-module'

import { CampaignTypeEnum } from 'src/Types/campaigns'

import { EventNameEnum, EventTypeEnum } from '../tagManagerEnums'

export const genreAddedEvent = ({
  campaignType,
  genreId,
  genreName,
  platformName,
  userId,
  campaignId,
  campaignNumber,
  subscriptionPlan,
}: {
  campaignType: string | CampaignTypeEnum
  genreId: string | undefined
  genreName: string | undefined
  platformName?: string
  userId?: string
  campaignId?: number | string
  campaignNumber?: number
  subscriptionPlan?: string
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GenreAdded,
      event_name: EventNameEnum.GenreAdded,
      'campaign-type': campaignType,
      'campaign-platform': platformName,
      'track-platform': platformName,
      'campaign-id': campaignId,
      userID: userId,
      'genre-name': genreName,
      'genre-id': genreId,
      'campaign-number':
        campaignType === CampaignTypeEnum.FIRST ? 1 : campaignNumber,
      ...(subscriptionPlan ? { subscription_plan: subscriptionPlan } : {}),
    },
  })
}

export const genreRemovedEvent = ({
  campaignType,
  genreId,
  genreName,
  platformName,
  userId,
  campaignId,
}: {
  campaignType: string
  genreId?: number
  genreName?: string
  platformName?: string
  userId?: string
  campaignId?: number
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GenreRemoved,
      event_name: EventNameEnum.GenreRemoved,
      'campaign-type': campaignType,
      'campaign-platform': platformName,
      'track-platform': platformName,
      'campaign-id': campaignId,
      userID: userId,
      'genre-name': genreName,
      ...(genreId ? { 'genre-id': genreId } : {}),
    },
  })
}

export const genrePopupOpenedEvent = ({
  campaignType,
  platformName,
  campaignNumber,
  campaignId,
  userId,
}: {
  campaignType: string | CampaignTypeEnum
  platformName?: string
  campaignNumber?: number
  campaignId?: number | string
  userId?: string
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,
      event_params: {
        event_name: EventNameEnum.GenrePopupOpened,
        'campaign-type': campaignType,
        'campaign-platform': platformName,
        'campaign-number':
          campaignType === CampaignTypeEnum.FIRST ? 1 : campaignNumber,
        'campaign-id': campaignId,
      },
      user_properties: {
        ...(userId ? { userID: userId } : {}),
      },
    },
  })
}

export const popupGenreAddedEvent = ({
  campaignType,
  platformName,
  campaignNumber,
  campaignId,
  genreName,
  genreId,
  userId,
}: {
  campaignType: string | CampaignTypeEnum
  platformName?: string
  campaignNumber?: number
  campaignId?: number | string
  genreName: string | undefined
  genreId?: number
  userId?: string
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,
      event_params: {
        event_name: EventNameEnum.PopupGenreAdded,
        'campaign-type': campaignType,
        'campaign-platform': platformName,
        'campaign-number':
          campaignType === CampaignTypeEnum.FIRST ? 1 : campaignNumber,
        'campaign-id': campaignId,
        'genre-name': genreName,
        ...(genreId ? { 'genre-id': genreId } : {}),
      },
      user_properties: {
        ...(userId ? { userID: userId } : {}),
      },
    },
  })
}
